module.exports = __webpack_public_path__ + "static/img/TX_H5.32b66d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/TX_H5.png
// module id = FlH/
// module chunks = 34